module.exports = __webpack_public_path__ + "img/kovatek-logo.004ef1a8.png";